export function cleanSabreToken(raw) {
  let value = String(raw || '').trim()
  const tokenMatch = value.match(/[?&]token=([^&#\s]+)/i)
  if (tokenMatch) {
    try {
      value = decodeURIComponent(tokenMatch[1])
    } catch (_) {
      value = tokenMatch[1]
    }
  }
  return value.replace(/^token=/i, '').trim()
}
